const transportation = {
  Madrid: {
    enabled: true,
    basePrice: 12,
    airportPrice: 24,
    airportZone: "－机场",
    vanPrice: 35,
  },

  Barcelona: {
    enabled: true,
    basePrice: 12,
    airportPrice: 36,
    airportZone: "－机场",
    vanPrice: null // no vans in barcelona https://cabify.com/es/spain/barcelona
  },

  Sevilla: {
    enabled: true, 
    basePrice: 10,
    airportPrice: 18,
    airportZone: "－机场",
    vanPrice: 35,
  },

  // Nota sobre Málaga:
  // Málaga es diminuta y poco transitable en coche.
  // Hay Cabify, pero no opera igual todo el año y en general 
  // no merece la pena.
  // De momento prefiero no meterlo.
  // Jesús
}
    
export default transportation



// WEBPACK FOOTER //
// ./data.transportation.js